import { useState } from 'react';
import { useTheme } from '../context/ThemeContext';
import { COUNTRIES, getCountry } from '../data/countryCodes';

const ERROR_RED = '#ff3d6b';

/**
 * Country code picker + local number. The native <select> is invisible over a
 * compact "IN +91 ▼" face: the closed control stays narrow while the OS picker
 * (keyboard and screen-reader friendly) handles choosing.
 *
 * `inputStyle` is the caller's base field style so it matches the surrounding form.
 */
export default function PhoneInput({
  countryIso, onCountryChange, value, onChange,
  invalid = false, inputStyle, codeWidth = '100px', placeholder = 'Phone number',
}) {
  const { colors } = useTheme();
  const [codeFocused, setCodeFocused] = useState(false);

  return (
    <div style={{ display: 'flex', gap: '0.5rem' }}>
      <div style={{ position: 'relative', flexShrink: 0, width: codeWidth }}>
        <div
          aria-hidden="true"
          style={{
            ...inputStyle,
            display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '0.3rem',
            height: '100%', whiteSpace: 'nowrap',
            borderColor: codeFocused ? colors.accent : colors.border,
          }}
        >
          <span>{countryIso} +{getCountry(countryIso).dial}</span>
          <span style={{ fontSize: '0.6rem', color: colors.muted }}>▼</span>
        </div>
        <select
          value={countryIso}
          onChange={(e) => onCountryChange(e.target.value)}
          onFocus={() => setCodeFocused(true)}
          onBlur={() => setCodeFocused(false)}
          aria-label="Country code"
          style={{
            position: 'absolute', inset: 0, width: '100%', height: '100%',
            opacity: 0, cursor: 'pointer', fontSize: '16px',
          }}
        >
          {COUNTRIES.map(c => (
            <option key={c.iso} value={c.iso}>{c.name} (+{c.dial})</option>
          ))}
        </select>
      </div>
      <input
        type="tel"
        inputMode="tel"
        autoComplete="tel-national"
        placeholder={placeholder}
        aria-label="Phone number"
        aria-invalid={invalid}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        style={{ ...inputStyle, flex: 1, minWidth: 0, borderColor: invalid ? ERROR_RED : colors.border }}
      />
    </div>
  );
}
